import * as React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import ServiceViewTabs from '../../../containers/services/ServiceViewTabs'
import ServiceViewHeader from '../../../containers/services/ServiceViewHeader'
import ServiceViewMainInfo from '../../../containers/services/ServiceViewMainInfo'
import ServiceViewPricingBreakdown from '../../../containers/services/ServiceViewPricingBreakdown'
import ServiceViewProviders from '../../../containers/services/ServiceViewProviders'
import ServiceViewProducts from '../../../containers/services/ServiceViewProducts'
import ServiceViewServiceDays from '../../../containers/services/ServiceViewServiceDays'
import ServiceViewMember from 'src/containers/services/ServiceViewMember'
import { SERVICE_EDIT_URL } from '../../../state/constants/index'
import GoinZonesPane from '../../../containers/services/GoinZonesPane'
import AfterHoursReportPDF from 'src/containers/services/AfterHoursReportPDF'
import BackToList from 'src/components/ui/BackToList'
import { IRiderFilters } from 'src/types'
import ServiceViewPassengerType from 'src/containers/services/ServiceViewPassengerType'
import Access2Care from 'src/containers/services/Access2Care'
import ModivcareTripLogPDFNew from 'src/containers/services/ModivcareTripLogPDFNew'
import ServiceViewSuggestedLocations from 'src/containers/services/ServiceViewSuggestedLocations'
import ServiceViewGroupRideSettings from 'src/containers/services/ServiceViewGroupRideSettings'
import ServiceViewDesignatedHotspots from 'src/containers/services/ServiceViewDesignatedHotspots'

interface IServiceViewPaneProps {
  serviceId: string
  orgId: string
  routeProps: RouteComponentProps<any>
  onComponentMount: (serviceId: string) => void
}

class ServiceViewPane extends React.Component<IServiceViewPaneProps> {
  constructor(props: IServiceViewPaneProps) {
    super(props)
  }

  public componentDidMount() {
    this.props.onComponentMount(this.props.serviceId)
  }

  public render() {
    const { routeProps } = this.props

    return (
      <div>
        <BackToList link='/services' className='flex' />
        <ServiceViewHeader routeProps={routeProps} />
        <ServiceViewTabs routeProps={routeProps} />

        <Switch>
          <Route path={`${routeProps.match.path}/access2care`} component={Access2Care} />
          <Route
            path={`${routeProps.match.path}/modivcare`}
            component={() => <ModivcareTripLogPDFNew serviceId={this.props.serviceId} />}
          />
          <Route path={`${routeProps.match.path}/afterhoursreport`} component={AfterHoursReportPDF} />
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.PROVIDERS_AND_PRODUCTS}`}
            render={this.renderProvidersAndProducts}
          />
          <Route path={`${routeProps.match.path}/${SERVICE_EDIT_URL.PRODUCTS}`} render={this.renderProducts} />
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.SERVICE_DAYS_AND_HOURS}`}
            render={this.renderServiceDays}
          />
          <Route path={`${routeProps.match.path}/${SERVICE_EDIT_URL.GOIN_ZONES}`} render={this.renderZones} />
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.PRICING_BREAKDOWN}`}
            render={this.renderPricingBreakdown}
          />
          <Route path={`${routeProps.match.path}/${SERVICE_EDIT_URL.MEMBER}`} render={this.renderMember} />
          {/* Route for Rider Type */}
          <Route path={`${routeProps.match.path}/${SERVICE_EDIT_URL.PASSENGER_TYPES}`} render={this.renderRiderType} />
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.SUGGESTED_LOCATIONS}`}
            render={this.renderSuggestedLocations}
          />
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.GROUP_RIDE_SETTINGS}`}
            render={this.renderGroupRideSettings}
          />
          <Route
            path={`${routeProps.match.path}/${SERVICE_EDIT_URL.DESIGNATED_HOTSPOTS}`}
            render={this.renderDesignatedHotspots}
          />
          <Route path={`${routeProps.match.path}/${SERVICE_EDIT_URL.MAIN_INFO}`} render={this.renderMainInfo} />
        </Switch>
      </div>
    )
  }

  private renderMainInfo = (props: RouteComponentProps<any>) => (
    <ServiceViewMainInfo serviceId={props.match.params.id} path={props.match.path} />
  )

  private renderDesignatedHotspots = (props: RouteComponentProps<any>) => (
    <ServiceViewDesignatedHotspots serviceId={props.match.params.id} />
  )

  private renderProvidersAndProducts = (props: RouteComponentProps<any>) => (
    <ServiceViewProviders serviceId={props.match.params.id} />
  )

  private renderProducts = (props: RouteComponentProps<any>) => (
    <ServiceViewProducts serviceId={props.match.params.id} />
  )

  private renderServiceDays = (props: RouteComponentProps<any>) => (
    <ServiceViewServiceDays serviceId={props.match.params.id} />
  )

  private renderZones = (props: RouteComponentProps<any>) => {
    if (!this.props.serviceId) {
      return null
    }
    return <GoinZonesPane serviceId={this.props.serviceId} {...props} viewMode={true} />
  }

  private renderPricingBreakdown = (props: RouteComponentProps<any>) => (
    <ServiceViewPricingBreakdown serviceId={props.match.params.id} />
  )

  private renderMember = (props: RouteComponentProps<any>) => <ServiceViewMember serviceId={props.match.params.id} />

  private renderRiderType = (props: RouteComponentProps<any>) => (
    <ServiceViewPassengerType serviceId={props.match.params.id} />
  )

  private renderSuggestedLocations = (props: RouteComponentProps<any>) => {
    return <ServiceViewSuggestedLocations serviceId={props.match.params.id} />
  }
  private renderGroupRideSettings = (props: RouteComponentProps<any>) => {
    return <ServiceViewGroupRideSettings serviceId={props.match.params.id} />
  }
}

export default ServiceViewPane



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewPane.tsx